module.exports = __webpack_public_path__ + "static/media/16_3.65becefc.jpg";